var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C15 19.8284 14.3284 20.5 13.5 20.5C12.6716 20.5 12 19.8284 12 19C12 18.1716 12.6716 17.5 13.5 17.5C14.3284 17.5 15 18.1716 15 19Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C11.4477 4.5 11 4.94772 11 5.5H9C9 3.84315 10.3431 2.5 12 2.5C13.6569 2.5 15 3.84315 15 5.5H13C13 4.94772 12.5523 4.5 12 4.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8207 17.1404L17.3645 13.8558L15.0197 11.5109L14.4626 7.5H9.53738L8.14849 17.5H15.8515L15.4759 14.7956L17.8207 17.1404ZM9.00876 5.5H15.3333C15.8325 5.5 16.2552 5.86805 16.3238 6.36243L17.9905 18.3624C18.0303 18.6489 17.9441 18.9386 17.7542 19.1567C17.5643 19.3748 17.2892 19.5 17 19.5H7C6.71079 19.5 6.43574 19.3748 6.24582 19.1567C6.05591 18.9386 5.96972 18.6489 6.00951 18.3624L7.59893 6.9186L9.37185 8.69152L9.53738 7.5L11.0087 7.49999L9.00876 5.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29289 3.79289C3.68342 3.40237 4.31658 3.40237 4.70711 3.79289L20.7071 19.7929C21.0976 20.1834 21.0976 20.8166 20.7071 21.2071C20.3166 21.5976 19.6834 21.5976 19.2929 21.2071L3.29289 5.20711C2.90237 4.81658 2.90237 4.18342 3.29289 3.79289Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMute);
export default __webpack_public_path__ + "static/media/notification-mute.9c515504256a49c28806b3008301498d.svg";
export { ForwardRef as ReactComponent };